import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PARAMS } from '../../../contants/PARAMS';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';

@Component({
  selector: 'ztsi-tabs-penalty-expense-select',
  templateUrl: './ztsi-tabs-penalty-expense-select.component.html',
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiTabsPenaltyExpenseSelectComponent),
			multi: true
		}
	]
})
export class ZtsiTabsPenaltyExpenseSelectComponent implements ControlValueAccessor {
	options = [
		{ label: '0', value: 0 },
		{ label: 'Early - 1,840', value: 1840 },
		{ label: 'No show - 3,640', value: 3640 },
	];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._parameterService.getCachedSystemParameterArray<string>(PARAMS.DAILY_TRIP_TABS_PENALTY_OPTION, 3600).subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.options = response.map(x => {
					var t = x.split('--');
					return { label: t[1], value: parseInt(t[0]) };
				});
			}
			else {
				console.log('Unable to load expense type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-tabs-penalty-expense-select/ztsi-tabs-penalty-expense-select.component.ts